import { useTranslations } from "next-intl";
import EmptyCartSvg from "@/assets/icons/empty-cart.svg";

export const NoDiscounts = () => {
  const t = useTranslations();
  return (
    <div className="flex h-full flex-col items-center justify-center md:py-20">
      <EmptyCartSvg />
      <p className="mt-4 text-center font-medium text-xl">
        {t("discounts.noDiscounts")}
      </p>
    </div>
  );
};
